import React from "react";

const DashboardContainer = ({ children }) => {
  return (
    <div
      className="group relative bg-white p-4 sm:p-5 w-full mt-5 mb-3 transition-shadow duration-300"
      style={{
        borderRadius: "1.4rem 0.5rem 1.4rem 0.5rem",
        boxShadow:
          "0 1px 2px rgba(28,20,16,0.04), 0 12px 30px -14px rgba(217,119,6,0.18)",
      }}
    >
      {/* Gradient accent stripe, echoing the site's amber palette */}
      <div
        aria-hidden="true"
        className="absolute top-0 left-6 right-6 h-[3px] rounded-b-full"
        style={{ background: "linear-gradient(to right, #D97706, #EA580C)" }}
      />

      {/* Soft corner glow, subtle on hover */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-6 -right-6 w-24 h-24 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-2xl"
        style={{ background: "radial-gradient(circle, #FDE8CD, transparent 70%)" }}
      />

      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default DashboardContainer;